// src/utils/companyConfig.ts

/**
 * Maps memberUuid → company name.
 * Add all converse memberUuids (production + local + staging) below.
 */
const companyMemberUuidConfig: Record<string, string> = {
    "656f9a98-a100-494d-ad90-ef4f6f0e1020": "converse", // Production / converse
    "2ef6bbd7-90f1-4889-aff5-d7a95347064c": "converse", // Local / converse
	"e86fcea5-b5bc-43e5-9286-9f05eceed7f2": "converse", // Staging / converse
};

export function getCompanyName(memberUuid: string | null | undefined): string | null {
    if (!memberUuid) return null;
    return companyMemberUuidConfig[memberUuid] ?? null;
}

export function isConverseUser(memberUuid: string | null | undefined): boolean {
    return getCompanyName(memberUuid) === "converse";
}